<template>
  <v-container fluid class="ma-0 pa-0">
    <div>
          <v-subheader class="headline font-weight-bold mt-10">Ledger Amount</v-subheader>
        </div>
    <v-row dense>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <span style="font-size:14px;" class="black--text ">
                  <v-icon class="mr-1" color="primary" size="25">mdi-calendar</v-icon>Till
                </span>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Today's
                  Date</v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title   class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    data && data.transactionAmount ? numberWithCommas(data.transactionAmount.approveAmount) : 0.0}}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Closing Balance</v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1">
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <span style="font-size:14px;" class="black--text ">
                  <v-icon class="mr-1" color="primary" size="25">mdi-calendar</v-icon>Till
                </span>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Today's
                  Date</v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr">
                    {{ data && data.transactionAmount ? numberWithCommas(data.transactionAmount.holdAmount) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Balance Reserved for Order in
                    Progress</v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <span style="font-size:14px;" class="black--text ">
                  <v-icon class="mr-1" color="primary" size="25">mdi-calendar</v-icon>Till
                </span>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Today's
                  Date</v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    data && data.transactionAmount ? numberWithCommas(data.transactionAmount.netAmount) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Net Closing Balance
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <span style="font-size:14px;" class="black--text ">
                  <v-icon class="mr-1" color="primary" size="25">mdi-calendar</v-icon>Till
                </span>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Today's
                  Date</v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    data && data.assignVirtualOrders && data.assignVirtualOrders[0] ? numberWithCommas(data.assignVirtualOrders[0].totalPrice) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Curriculum kit2 freeze amount
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col> -->
    </v-row>
    <v-row class="mt-3" dense>
      <v-col cols="12" class="d-lg-flex justify-space-between" >
        <v-subheader class="headline font-weight-bold"> Orders</v-subheader>
        <v-autocomplete style="max-width:350px;" dense hide-details="true" class="my-0 py-1" solo
          key="id" menu-props="auto" v-model="kit" @change="getOrderByKit" label="---All Kits---"
          required :items="constantKit" item-text="name" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <span style="font-size:14px;" class="black--text ">
                  <v-icon class="mr-1" color="primary" size="25">mdi-calendar</v-icon>Till
                </span>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Today's
                  Date</v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    data && data.order && orderObj && orderObj.totalPrice ? numberWithCommas(orderObj.totalPrice) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Total Order Amount
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1">
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <v-card-title  class="font-weight-bold ma-0 pa-0 body-3" style="color:#424242;" v-text="data && data.order && orderObj && orderObj.countFail ? orderObj.countFail : '0'" ></v-card-title>
                <v-card-subtitle style="font-size:14px;" class="black--text ma-0 pa-0">Total Count
                </v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    data && data.order && orderObj && orderObj.amountFail ? numberWithCommas(orderObj.amountFail) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Order Failed or Pending
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <v-card-title  class=" font-weight-bold ma-0 pa-0 body-3"  style="color:#424242;" v-text="data && data.order && orderObj && orderObj.countPending ? orderObj.countPending : '0'"></v-card-title>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0">Total Count
                </v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                   data && data.order && orderObj && orderObj.amountPending ? numberWithCommas(orderObj.amountPending) : 0.0}}
                   </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Order Paid & In-progress of
                    Shipment
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1">
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <v-card-title  class=" font-weight-bold ma-0 pa-0 body-3" style="color:#424242;" v-text="data && data.order && orderObj && orderObj.countPay ? orderObj.countPay : '0'" ></v-card-title>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0">Total Count
                </v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                   data && data.order && orderObj && orderObj.amountPay ? numberWithCommas(orderObj.amountPay) : 0.0 }}
                   </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Order Paid & Shipped
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" style="margin-top: 15px;" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <span style="font-size:14px;" class="black--text ">
                  <v-icon class="mr-1" color="primary" size="25">mdi-calendar</v-icon>Till
                </span>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Today's
                  Date</v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    data && data.assignVirtualOrders && data.assignVirtualOrders[0] ? numberWithCommas(data.assignVirtualOrders[0].totalPrice) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Curriculum kit2 freeze amount
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-3" dense>
      <v-col cols="12" class="d-lg-flex justify-space-between">
        <v-subheader class="headline font-weight-bold ">Royalty</v-subheader>
        <v-autocomplete style="max-width:350px;" dense hide-details="true" class="my-0 py-1" solo
          v-model="type" menu-props="auto" @change="getRoyaltyBytype" label="---All Type---" required :items="typeArr"
          item-text="name" item-value="id">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px; height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <v-card-title  class="font-weight-bold ma-0 pa-0 body-3" style="color:#424242;" v-text="royaltyObj && royaltyObj.count ? royaltyObj.count : '0'"></v-card-title>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Total Count
                </v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    royaltyObj && royaltyObj.totalPrice ? numberWithCommas(royaltyObj.totalPrice) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Total Royalty Installment Amount
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1" >
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px; height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <v-card-title  class=" font-weight-bold ma-0 pa-0 body-3" style="color:#424242;" v-text="royaltyObj && royaltyObj.countPaid ? royaltyObj.countPaid : '0'"></v-card-title>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0"> Paid Count
                </v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                    royaltyObj && royaltyObj.amountPaid ? numberWithCommas(royaltyObj.amountPaid) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Paid Royalty Installment Amount
                  </v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1">
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px ;height:105px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <v-card-title  class=" font-weight-bold ma-0 pa-0 body-3" style="color:#424242;" v-text="royaltyObj && royaltyObj.countTillDate ? royaltyObj.countTillDate : '0'"></v-card-title>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0">Due Count as on date
                </v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span  id="amountId" class="mdi mdi-currency-inr"> {{
                    royaltyObj && royaltyObj.amountTillDate ? numberWithCommas(royaltyObj.amountTillDate) : 0.0 }}
                    </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Due Royalty Installment Amount as on date</v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card color="orange" max-width="350px" min-width="150px" class="rounded-lg mx-auto pl-1"
          elevation="1">
          <div class="d-flex flex-no-wrap justify-space-between"
            style="background-color:white; min width:200px">
            <v-row no-gutters>
              <v-col cols="3" class="pa-2" style="border-right:1px solid #e5e5e5;">
                <v-card-title  class=" font-weight-bold ma-0 pa-0 body-3" style="color:#424242;" v-text="royaltyObj && royaltyObj.countUpcoming ? royaltyObj.countUpcoming : '0'"></v-card-title>
                <v-card-subtitle style="font-size:14px;" class=" black--text ma-0 pa-0">Upcoming Due Count
                </v-card-subtitle>
              </v-col>
              <v-col cols="9">
                <div>
                  <v-card-title class="text-h5 black--text"><span id="amountId" class="mdi mdi-currency-inr"> {{
                   royaltyObj && royaltyObj.amountUpcoming ? numberWithCommas(royaltyObj.amountUpcoming) : 0.0 }}
                   </span>
                  </v-card-title>
                  <v-card-subtitle class="secondary--text body-2">Upcoming Due Royalty Installment
                    Amount</v-card-subtitle>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
// @ is an alias to /src
// import * as chartConfig from '@/components/template/Charts/chart.config'
// import Utils from '@/utils'
import constants from '@/utils/constants'
import _ from 'lodash'
// import RupeesCard from '../components/template/RupeesCard.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'financeDashboard',
  // components: { RupeesCard },
  data () {
    return {
      size: '6rem',
      constantKit: [{ id: '', name: 'Select All' }].concat(constants.KIT),
      inProgress: false,
      kit: '',
      data: [],
      academicYearID: '',
      franchiseeID: '',
      isLoading: false,
      type: '',
      typeArr: [
        {
          id: '',
          name: 'All Types'
        },
        {
          id: 'FOFO',
          name: 'FOFO'
        },
        {
          id: 'COCO',
          name: 'COCO'
        }
      ],
      royaltyObj: {
        totalPrice: '0.00',
        count: 0,
        amountTillDate: '0.00',
        amountUpcoming: '0.00',
        amountPaid: '0.00',
        countPaid: '0',
        countTillDate: '0',
        countUpcoming: '0',
        type: 'TOTAL'
      },
      orderObj: {
        amountFail: '0.00',
        amountPay: '0.00',
        amountPending: '0.00',
        count: 0,
        countFail: '0',
        countPay: 0,
        countPending: 0,
        kitType: '',
        totalPrice: '0.00'
      }
    }
  },
  async created () {
    this.$dialog.message.info('Finance Dashboard', {
      position: 'bottom-right',
      color: 'secondary',
      timeout: 3000
    })
    await this.onFranchiseeChange()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    makeEmpty: function () {
      this.kit = ''
      this.getOrderByKit()
    },
    numberWithCommas: function (value) {
      if (!value) {
        return '0.00'
      }
      value = Number(value).toFixed(2)
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
            this.data = ''
          }
          this.orderObj = {
            amountFail: '0.00',
            amountPay: '0.00',
            amountPending: '0.00',
            count: 0,
            countFail: '0',
            countPay: 0,
            countPending: 0,
            kitType: '',
            totalPrice: '0.00'
          }
          this.kit = ''
          await this.totalCount()
          this.getOrderByKit()
          this.getRoyaltyBytype()
        }
      } finally {
        this.inProgress = false
      }
    },
    getRoyaltyBytype: function () {
      if (_.isEmpty(this.type)) {
        this.royaltyObj = _.filter(this.data.royaltyData, {
          type: 'TOTAL'
        }).map((v) => v)
        this.royaltyObj = this.royaltyObj[0]
      } else {
        this.royaltyObj = _.filter(this.data.royaltyData, {
          type: this.type
        }).map((v) => v)
        this.royaltyObj = this.royaltyObj[0]
      }
    },
    getOrderByKit: function () {
      if (!_.isEmpty(this.kit)) {
        console.log(this.data.order, 'data.order')
        let order = _.find(this.data.order, (item) => item.kitType === this.kit)
        if (!_.isEmpty(order)) {
          this.orderObj = order
        } else {
          this.orderObj = {
            amountFail: '0.00',
            amountPay: '0.00',
            amountPending: '0.00',
            count: 0,
            countFail: '0',
            countPay: 0,
            countPending: 0,
            kitType: '',
            totalPrice: '0.00'
          }
        }
      } else {
        this.orderObj = {
          totalPrice: _.sumBy(this.data.order, (item) => Number(item.totalPrice)),
          amountFail: _.sumBy(this.data.order, (item) => Number(item.amountFail)),
          amountPay: _.sumBy(this.data.order, (item) => Number(item.amountPay)),
          amountPending: _.sumBy(this.data.order, (item) => Number(item.amountPending)),
          count: _.sumBy(this.data.order, (item) => Number(item.count)),
          countFail: _.sumBy(this.data.order, (item) => Number(item.countFail)),
          countPay: _.sumBy(this.data.order, (item) => Number(item.countPay)),
          countPending: _.sumBy(this.data.order, (item) => Number(item.countPending)),
          kitType: ''
        }
      }
    },
    totalCount: async function () {
      this.isLoading = true
      try {
        var formData = {}
        if (this.franchiseeID) {
          formData = {
            params: {
              franchiseeID: this.franchiseeID
            }
          }
        }
        const { data } = await http.get(`${constants.API_URL}/api/get-amount-count`, formData)
        this.data = data
        if (!_.isEmpty(this.data.royaltyData)) {
          this.royaltyObj = _.filter(this.data.royaltyData, {
            type: 'TOTAL'
          }).map((v) => v)
          this.royaltyObj = this.royaltyObj[0]
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style scoped>
#amountId{
  color: #424242;
  font-weight: 600%;
}

</style>
